import locales from './uploader-translations/locales.json'

const defaultLang = 'it'

export default ({ preview_url, import_url }) => ({
  currentStep: 0,
  steps: [
    { title: locales[defaultLang].upload_title, desc: locales[defaultLang].upload_desc },
    { title: locales[defaultLang].mapping_title, desc: locales[defaultLang].mapping_desc },
    { title: locales[defaultLang].import_title, desc: locales[defaultLang].import_desc },
  ],
  init(){
    this.$refs.progress.style.transform = `translateX(-66.6%)`

    this.$watch('currentStep', (newVal) => {
      const prc = 100 * (newVal + 1) / this.steps.length
      this.$refs.progress.style.transform = `translateX(-${100 - prc}%)`
    })
  },
  isDragging: false,
  isUploading: false,
  headersMapping: {
    source: [],
    matchings: [],
  },
  uploadedFileData: {},
  previewData: {
    headers: [],
    values: [],
  },
  importId: null,
  onFileAdded(inputObj){
    this.isDragging = false

    const file = inputObj.files[0]
    const allowedTypes = this.$root.querySelector('input[type=file]').accept.split(',').map(item => item.trim())
    const isAllowed = allowedTypes.some(type => file.name.toLowerCase().endsWith(type.toLowerCase()))
    const isAccepted = isAllowed && file.size < 10485760 // 10MB
    if(isAccepted){
      this.doUpload(file)
    }else{
      this.$dispatch('toast', { type: 'alert', message: locales[defaultLang].invalid_file })
    }
  },
  doUpload(file){
    this.isUploading = true
    const formData = new FormData()
    formData.append('file', file)
    axios({
      method: 'POST',
      url: preview_url,
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
      },
      data: formData
    })
    .then((res) => {
      const data = res.data
      this.isUploading = false
      console.log(data)
      this.headersMapping.source = data.parsed_file.source_header
      this.headersMapping.matchings = data.parsed_file.matching_header
      this.uploadedFileData = data.file_data
      this.importId = data.data_import_id
      this.previewData.headers = data.parsed_file.source_header
      this.previewData.values = data.parsed_file.first_data_row
      this.advance()

      this.$nextTick(() => {
        this.headersMapping.matchings.forEach((el, i) => {
          const selectEl = document.querySelector(`#source_map_${i}`)
          if(el.source) selectEl.value = el.source
          selectEl.checkValidity()
        })
        this.$dispatch('alpine-refresh')
        this.$refs.mapping.classList.add('was-validated')
      })
    })
    .catch((error) => {
      this.isUploading = false
      this.$dispatch('toast', { type: 'alert', message: locales[defaultLang].error })
      console.log(error)
    })
  },
  advance(){
    this.currentStep += 1
    if(this.currentStep == this.steps.length-1){
      // submit mapping and do import
      this.$refs.mapping.querySelector('input[name=data_import_id]').value = this.importId
      this.$refs.mapping.action = import_url
      this.$refs.mapping.requestSubmit()
    }
  }
})